/**
 * Runtime environment helper
 * Server: reads from process.env
 * Client: reads from window.__ENV__ (injected by _document.jsx)
 *
 * Usage:
 *   import { getEnv } from '@/lib/env';
 *   const apiUrl = getEnv('NEXT_PUBLIC_API_URL');
 */

export const getEnv = key => {
  // Client-side: use runtime config injected by _document.jsx
  if (typeof window !== 'undefined' && window.__ENV__) {
    return window.__ENV__[key];
  }
  // Server-side: use process.env
  return process.env[key];
};

export default getEnv;
